import { requestHandler } from "../Store";

export const getCustomerNotifications = (token, user_id, store_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/store/${store_id}/notifications`,
    token,
  });
};
export const getUnreadNotificationsCount = (token, user_id, store_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/store/${store_id}/notifications/unread`,
    token,
  });
};
export const updateNotificationsStatus = (token, user_id) => {
  return requestHandler({
    method: "PUT",
    url: `users/${user_id}/notifications/status/update`,
    token,
  });
};
